import React from 'react';
import "../css/home.css";
import Product from './Product';

function Home() {
    return (
        <div className="home">
            <div className="home__container">
                <img className="home__image" src="https://images-eu.ssl-images-amazon.com/images/G/31/AmazonVideo/2020/X-site/Multititle/Bollywood/1500x600_Hero-Tall_np_bolly._CB405289994_.jpg" alt="" />
            
            <div className="home__row">
                <Product
                id="1"
                title="Acer Aspire 5 Slim Laptop, 15.6 inches Full HD IPS Display, AMD Ryzen 3 3200U, Vega 3 Graphics, 4GB DDR4, 128GB SSD, Backlit Keyboard, Windows 10 in S Mode, A515-43-R19L, Silver"
                price={499.99}
                image="https://images-na.ssl-images-amazon.com/images/I/71vvXGmdKWL._AC_SL1500_.jpg"
                rating={5} />
                <Product 
                id="2"
                title="Letsfit Smart Watch User Guide: A Quick and Easy Guide with Tips & Tricks to Maximizing your Letsfit Smart Watch"
                price={9.99}
                image="https://m.media-amazon.com/images/I/41sczfhpyJL.jpg"
                rating={4} />
                
                
              
            </div>
            <div className="home__row">
            <Product
                id="3"
                title="Amazon Echo: The Ultimate User Guide & Manual To Alexa (2017 Edition) (FREE PDF Bonus Inside)"
                price={15.99}
                image="https://m.media-amazon.com/images/I/416k4Hdt71L.jpg"
                rating={3}
            />
            <Product 
                id="4"
                title="TP-Link AC1750 Smart WiFi Router (Archer A7) -Dual Band Gigabit Wireless Internet Router for Home, Works with Alexa, VPN Server, Parental Control, QoS"
                price={10.99}
                image="https://images-na.ssl-images-amazon.com/images/I/51R2a9p-vNL._AC_SL1000_.jpg"
                rating={5} />
                
                <Product 
                id="5"
                title="FullfilmentAmazon Basics Hardside Carry-On Spinner Suitcase Luggage - Expandable with Wheels - 21 Inch, Black"
                price={115.99}
                image="https://images-na.ssl-images-amazon.com/images/I/71s7HbyqzEL._AC_SL1500_.jpg"
                rating={4} />
                
                

            </div>
            <div className="home__row">
    
            <Product 
                id="6"            
                title="SAMSUNG 43-inch Class Crystal UHD TU-8000 Series - 4K UHD HDR Smart TV with Alexa Built-in (UN43TU8000FXZA, 2020 Model)
"
                price={1000.99}
                image="https://images-na.ssl-images-amazon.com/images/I/71RiQZ0J2SL._AC_SL1000_.jpg"
                rating={4} />
                
            </div>
            </div>
            
        </div>
    )
}

export default Home;
